export { unstable_generateUtilityClass as generateUtilityClass } from '@mui/utils';